<app-kontable title = "{{supplier.code}} - {{ 'common.supplier_certs_title' | translate }}"
              [columns] = "['id', 'certification_id', 'certification_code']"
              [titles] = "['common.id', 'common.certification_id', 'common.certification_code']"
              [showInfoButton]="false"
              [showRecoverButton]="false"
              [showGlobalFilter]="false"
              [showDetailsButton]="false"
              [showAddButton]="true"
              [konPermissions]="perm"
              [source]="certifications"
              (onAdd)="showAddOrEditDialog($event)"
              (onRemove)="delete($event)">
</app-kontable>

<p-dialog *ngIf="svc.editing_supplier_certification"
          [width]="500"
          header="{{modalTitle}}"
          [(visible)]="svc.editing_supplier_certification"
          [responsive]="true"
          showEffect="fade"
          [modal]="true"
          (onHide)="onDialogHide()">

    <app-supplier-certification-form
            (onAddElement)="onAddElement($event)">
    </app-supplier-certification-form>
</p-dialog>



// WEBPACK FOOTER //
// ./src/app/views/administration/supplier/supplier-certification/supplier-certification.component.html